<template>
    <div>
        <div class="fund-list">
            <div v-for="(fund, $index) in fundList" :key="$index" class="fund-list--item">
                <WatchFundTile
                    :fund-id="fund.item_id"
                    :fund-name="fund.item_name"
                    :fund-author="fund.partner_name"
                    :thumbnail-uri="`/data/fund/${fund.item_id}/top.jpg`"
                    :watch-list-count="fund.watchlist_count"
                    :investor-count="fund.investor_count"
                    :comment-count="fund.comment_count"
                    :article-count="fund.article_count"
                    :fund-status="fund.fund_status"
                />
            </div>
            <InfiniteLoading @infinite="infiniteListHandler">
                <template #complete>
                    <span> </span>
                </template>
            </InfiniteLoading>
        </div>
        <div v-if="isListEmpty" class="text-center">
            登録アイテムはありません
        </div>
    </div>
</template>

<style scoped>
.fund-list{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
    max-width: 800px;
}

.fund-list--item{
    width: 100%;
}
</style>

<script>
import axios from "axios"
import InfiniteLoading from "v3-infinite-loading"
import "v3-infinite-loading/lib/style.css"
import WatchFundTile from "../components/WatchFundTile"
const fundListApi = '/api/watch/funds'

export default {
    name: 'WatchFunds',
    components: {
        InfiniteLoading,
        WatchFundTile,
    },
    data: () => ({
        fundListPage: 0,
        fundList: [],
        isListEmpty: false,
    }),
    mounted() {},
    created() {},
    methods: {
        async infiniteListHandler($state) {

            const res = await axios.get(fundListApi, {
                params: {
                    limit: 10,
                    pg: this.fundListPage
                }
            }).catch((error) => {
                console.log(error)
                return;
            });

            this.$nextTick(()=>{
                this.$emit('been-ready')
            })

            console.log(res)

            if (res.data.length > 0) {
                this.fundListPage++;
                this.fundList.push(...res.data);
                $state.loaded();
            } else {
                $state.complete();
                this.isListEmpty = this.fundList.length == 0
            }
        }
    }
}
</script>